import { createApp } from 'vue'
import { provideApolloClient } from '@vue/apollo-composable'
import { createPinia } from 'pinia'
import { apolloClient } from './utils/apolloClient'
import { sentryInit } from './utils/sentry'
import gtmClient from './utils/gtmClient'
import router from './router'
import { listenRemoteRoutes } from '@/router/remoteRoutes'
import { head } from '@/utils/head'

import App from '@/App.vue'
import { initialize as initializeAmplitude, createAmplitude } from '@outputinc/o-analytics'
import { createLaunchDarkly } from './utils/launchDarklyClient'

import sessionStorageParams from './scripts/session-storage-params'

const amplitudeKey = import.meta.env.VITE_OUTPUT_AMPLITUDE_KEY

// Save url params in sessionStorage
sessionStorageParams()

// Initialize LaunchDarkly (non-blocking; flags stream in after mount)
const { plugin: launchDarkly } = createLaunchDarkly()

const app = createApp(App)
const pinia = createPinia()
const amplitudeClient = createAmplitude(amplitudeKey)

provideApolloClient(apolloClient)

initializeAmplitude(amplitudeKey)

app.use(head)
app.use(pinia)
app.use(launchDarkly)
app.use(router)
app.use(amplitudeClient)
app.use(gtmClient)

// Mount the app
app.mount('#app')

// Initialize Sentry
sentryInit(app)
listenRemoteRoutes(router)
